<template>
    <div class="form-container">
      <el-card class="header-card"></el-card>
      <el-card class="desc-card">
        <div class="header" dir="auto" role="heading" aria-level="1">The Owner Rekryteringsinformation<br><span></span></div>
        <div class="text">
          ✅  <span style="font-weight: bold;font-size: 16px;">Företagsintroduktion:</span>
          <p style=" text-indent: 2em;">The Owner är ett USA-baserat SaaS-företag som tillhandahåller onlinebeställnings- och marknadsföringslösningar till oberoende restauranger.</p>
          <p style=" text-indent: 2em;">Vi hjälper lokala företagare att driva framgångsrika onlineverksamheter med verktyg som webbplatsbyggare, anpassade mobilappar, leverans utan provision, lojalitetsprogram och automatiserad marknadsföring. Av denna anledning väljer många handlare The Owner för att hjälpa till att optimera sina produkter.</p>
          <p style=" text-indent: 2em;">Med hjälp av plattformens AI-system kan handlare snabbt matcha produkter och skicka in uppgifter på bara 2-5 sekunder.</p>
          <p style=" text-indent: 2em;">Tillbringa bara 20-40 minuter om dagen för att utföra uppgifter effektivt och tjäna extra inkomst.</p>
          <p style=" text-indent: 2em;">Vi använder intelligent AI för att generera riktig data för att hjälpa produkter att öka exponeringen, få femstjärniga recensioner, främja försäljning och i slutändan förbättra rankingen.</p>
          <p style=" text-indent: 2em;">Som riktiga användare använder vi våra anslutningar och pengar för att tillhandahålla data till handlare och tjäna provision.</p>
         
          ✅  <span style="font-weight: bold;font-size: 16px;">Rekrytering av externa restaurangrecensenter：</span><br>
          <p style=" text-indent: 2em;"> <span style="font-weight: bold;">Arbetstitel:</span> Remote catering recensent</p>
          <p style=" text-indent: 2em;"> <span style="font-weight: bold;">Arbetsbeskrivning:</span> Simulera konsumenter att genomföra verkliga transaktioner för att öka försäljningen och exponeringen av handlarnas rätter</p>
          <p style=" text-indent: 2em;"> <span style="font-weight: bold;">Lön:</span> $50-500 per dag, betalas dagligen!</p>
          <p style=" text-indent: 2em;"> <span style="font-weight: bold;">Krav:</span> Endast svenska invånare, ålder (25-59).</p>
          <p style=" text-indent: 2em;"> <span style="font-weight: bold;">Fördelar:</span>Flexibla arbetstider, ingen erfarenhet krävs!</p>
          📩<span style="font-weight: bold;"> Ansök nu för att få din första startfinansiering：</span><br><br>
        </div>
        <el-form :model="form" ref="ruleFormRef" :rules="rules"  label-position="top">
          <el-form-item label="Fullständigt namn:" prop="name" class="bold-label">
            <el-input v-model="form.name"  placeholder="Fullständigt namn"/>
          </el-form-item>
          <el-form-item label="Telefon:" prop="phone"  class="bold-label">
            <el-input v-model="form.phone" placeholder="Telefon"/>
          </el-form-item>
          <el-form-item label="WhatsApp:" prop="whatsapp"  class="bold-label">
            <el-input v-model="form.whatsapp" placeholder="WhatsApp"/><el-text class="mx-1" type="danger">Du måste registrera ett Whatsapp-nummer, vår HR kontaktar dig via Whatsapp!</el-text>
          </el-form-item>
          <el-form-item label="Åldersintervall:" prop="age"  class="bold-label">
            <el-radio-group v-model="form.age">
              <el-radio :value="1">25-30</el-radio>
              <el-radio :value="2">31-40</el-radio>
              <el-radio :value="3">41-50</el-radio>
              <el-radio :value="4">51-65</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Live City:" prop="city" class="bold-label">
            <el-input v-model="form.city" placeholder="Live City"/>
          </el-form-item>
          <el-form-item label="Presentera dig själv:"  class="bold-label">
            <el-input
                v-model="form.intro"
                rows="5"
                type="textarea"
                placeholder="Presentera dig själv"
              />
          </el-form-item>
          <el-button type="primary" :loading="loading" @click="submitForm">Submit</el-button> 
          <el-text class="mx-1" type="success" v-if="result==1" style="margin-left: 10px;">Formuläret har skickats!</el-text>
          <el-text class="mx-1" type="danger" v-if="result==2" style="margin-left: 10px;">Serverfel!</el-text>
        </el-form>
      </el-card>
    </div>
  </template>
  
  <script setup>
  import { reactive,ref } from 'vue'
  import axios from 'axios';
  import { ElForm, ElFormItem, ElInput, ElButton, ElMessage } from 'element-plus';
  const ruleFormRef = ref(null)
  const loading = ref(false);
  const result = ref(0);
  const form = reactive({
    name: '',
    whatsapp: '',
    phone:'',
    age: '',
    city:'',
    intro: '',
  })
  
  const rules =reactive({
     name: [
        { required: true, message: "Fullständigt namn måste fyllas i", trigger: "blur" }
      ],
      age: [
        { required: true, message: "Åldersintervall måste fyllas i", trigger: "blur" }
      ],
      whatsapp: [
        { required: true, message: "WhatsApp måste fyllas i", trigger: "blur" }
      ],
      phone: [
        { required: true, message: "Telefon måste fyllas i", trigger: "blur" }
      ],
      city: [
        { required: true, message: "Live City måste fyllas i", trigger: "blur" }
      ]
    })
  
  const submitForm = () => {
    ruleFormRef.value.validate((valid, fields) => {
      if (valid) {
        loading.value = true;
        axios.post('/form-service/form/sweden', form)
          .then((response) => {
            loading.value = false;
            ElMessage.success('Formuläret har skickats');
            console.log(response.data);  // 后台返回的响应数据
            form.name='';
            form.whatsapp='';
            form.phone='';
            form.age='';
            form.city='';
            form.intro='';
            result.value=1
          }).catch((error) => {
            loading.value = false;
            ElMessage.error('Server Error');
            console.error(error);
            result.value=2
          });
      } else {
        console.log('error submit!', fields)
      }
    })
  }
  
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .bold-label {
    font-weight: bold;
  }
  .form-container {
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
  }
  .header-card {
      max-height: 22.5vw;
      max-width: 90vw;
      height: 320px;
      width: 640px;
      background-image: url('../assets/banner_sweden.jpg');
      background-size: cover;
      background-position: center;
      border: 1px solid rgb(218, 220, 224);
      border-radius: 8px 8px 0 0;
      margin-top: 12px;
      margin: auto;
      max-width: 90vw;
      width: 640px;
  }
  .desc-card {
      margin: auto;
      max-width: 90vw;
      width: 640px;
      background-color: transparent;
      box-shadow: none;
      margin-bottom: 0;
      padding-bottom: 0;
      word-wrap: break-word;
      color: rgb(32, 33, 36);
      text-align: left;
  }
  
  .desc-card .header{
      font-family: 'docs-Roboto';
      font-weight: 500;
      font-size: 20pt;
      line-height: 2;
      letter-spacing: 0;
  }
  
  .desc-card .text{
    font-family: 'docs-Roboto';
      font-weight: 400;
      font-size: 11pt;
      line-height: 1.6;
      letter-spacing: 0;
  }
  .radio-group-vertical {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
  }
  
  .el-radio:last-child {
       margin-left: 0 !important; 
  }
  
  </style>
  